import {flow} from 'lodash/fp';
import React from 'react';
import {connect} from 'react-redux';
import ISQAOpen from '../../validate/ISQAOpen';
import Validate from '../../validate/Validate';
import connectQuests from './common/connectQuests';
import {EventQuestsQuestionPostAnswer} from './EventQuestsQuestionPostAnswer';

class EventQuestsQuestionEditAnswer extends EventQuestsQuestionPostAnswer {
    constructor(props) {
        super(props);
        this.state.title = ' ';
    }
    submitAnswer(answer, anonymous, attachments) {
        return app.api.questions.updateAnswer(this.props.eventId, this.props.questionId, this.props.answerId, answer, anonymous, attachments);
    }
}

const ConnectedScreen = flow(
    connectQuests,
    connect((state, props) => {
        let question = state.events[props.eventId].questions.indexed[props.questionId];
        return {
            question,
            answer: _(question.answers.data).find(answer => answer.id == props.answerId),
        };
    })
)(EventQuestsQuestionEditAnswer);

export default props => (
    <ISQAOpen eventId={props.match.params.eventId}>
        <Validate
            validate={state => {
                if (
                    !state.events[props.match.params.eventId].questions.indexed[props.match.params.questionId].answers.data.find(
                        answer => answer.id == props.match.params.answerId
                    )
                ) {
                    throw new Error('Answer not found: ', props.answerId);
                }
            }}>
            <ConnectedScreen {...props.match.params} />
        </Validate>
    </ISQAOpen>
);
